import styled from "styled-components";
import { colors } from "src/theme/colors";
import devices from "src/constants/media";
import { typography } from "src/theme";

export const Wrapper = styled.div`
  background: ${colors.main};
  padding-bottom: 176px;
  color: white;
`;
export const TitleWrapper = styled.div`
  padding: 0 0 0 18px;
  margin: 16px 0 48px;
  @media ${devices.mobileM} {
    padding: 0 24px;
  }
  @media ${devices.mobileL} {
    padding: 0 56px;
    margin-top: 126px;
  }
  @media ${devices.tablet} {
    padding: 0 56px;
    margin-top: 16px;
  }
  @media ${devices.laptop} {
    padding: 0 68px;
  }
  @media ${devices.laptopS} {
    width: 1096px;
    padding: 0;
    margin: 16px auto 48px;
  }
`;

export const ReviewsContent = styled.div<{ height: string }>`
  height: ${({ height }) => height};
`;

export const BottomSection = styled.div`
  padding: 0 0 0 18px;
  display: block;
  @media ${devices.mobileM} {
    padding: 0 24px;
  }
  @media ${devices.mobileL} {
    padding: 0 46px 0 56px;
  }
  @media ${devices.tablet} {
    padding: 10px 56px;
  }
  @media ${devices.laptop} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 68px 0;
  }
  @media ${devices.laptopS} {
    width: 1096px;
    padding: 0;
    margin: 10px auto 0;
  }
`;
export const Text = styled.div`
  margin-top: 40px;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  max-width: 280px;
  color: ${colors.white};

  @media ${devices.mobileL} {
    max-width: 280px;
  }
  @media ${devices.tablet} {
    max-width: 536px;
    margin-top: 0;
  }
  @media ${devices.laptop} {
    max-width: 556px;
  }
  @media ${devices.laptopS} {
    font-size: 36px;
    line-height: 44px;
  }
`;
export const TextBox = styled.p`
  display: none;
  @media ${devices.tablet} {
    display: block;
  }
`;
export const RatesSection = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 0px;
  position: relative;
  margin-top: 40px;

  &::after {
    content: url("/illustrations/doodle-flare.svg");
    position: absolute;
    bottom: -70px;
    right: 10px;
  }

  @media ${devices.mobileL} {
    grid-column-gap: 20px;
  }
  @media ${devices.tablet} {
    width: 400px;
    &::after {
      content: url("/illustrations/doodle-flare.svg");
      position: absolute;
      bottom: -70px;
      right: -20px;
    }
  }
  @media ${devices.laptop} {
    margin-top: 0;
  }
`;
export const AppRateTitle = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.mainLight};
  margin-bottom: 12px;

  @media (min-width: 0px) and (max-width: 425px) {
    width: 120px;
  }
`;
export const RatesItem = styled.div``;
export const Rate = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 64px;
  line-height: 80px;
  margin-bottom: 12px;
`;
export const NumberOfReviews = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  font-size: 20px;
  color: ${colors.mainLight};
`;
export const Card = styled.div`
  padding: 0 12px;
`;
export const CardWrapper = styled.div`
  background-color: ${colors.white};
  width: 326px;
  height: 380px;
  border-radius: 10px;
  padding: 24px 24px;
  margin-bottom: 24px;
  box-shadow: 6px 6px 11px 1px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 6px 6px 11px 1px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 6px 6px 11px 1px rgba(0, 0, 0, 0.2);
  @media ${devices.tablet} {
    height: 200px;
    width: 536px;
  }
`;
export const CardTitle = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.greyDark};
  margin-bottom: 8px;
`;
export const RateDetails = styled.div`
  display: block;

  @media ${devices.mobileL} {
    display: flex;
    flex-direction: row;
  }
`;

export const RateStars = styled.div`
  color: ${colors.main};
  margin-bottom: 17px;
  padding-right: 10px;
`;
export const ReviewerDetails = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.grey};
  margin-bottom: 17px;
`;
export const ReviewText = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey};
`;

export const TextP = styled.p`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;

  @media ${devices.mobileS} {
    -webkit-line-clamp: 5;
  }
  @media ${devices.mobileL} {
    -webkit-line-clamp: 7;
  }
  @media ${devices.tablet} {
    -webkit-line-clamp: 3;
  }
`;
